module.exports = __webpack_public_path__ + "static/media/default-1.7360b64d.svg";